/**
 * better to ask Felix if you're not sure if something is general term or not
 * do not mistake with "simple" translations like "submit" or "cancel"
 * never use for composition
 *
 * generalTerm translations are something, which are specific to project "domain" or "project"
 * "common" translations are everything, which can be reused across different projects
 *
 * TODO: extract "common" above this object in order to reuse some translations
 */
export const generalTerm = {
  // common
  // do not mistake with "Load ID"
  // "Load ID" might or might not be indexing field for database
  // "Load Identifier" is a customer-written "comment" or "description" which they later use for internal usage
  loadIdentifier: 'Load Identifier',
  date: 'Date',
  name: 'Name',
  description: 'Description',
  event: 'Event | Events',
  mappedPT9800user: 'Mapped Protherm user',
  // equipment || asset
  asset: 'Asset',
  assetId: 'Asset id',
  assetType: 'Asset type',
  customer: 'Customer',
  composition: 'Composition',
  element: 'Element | Elements',
  root: 'Root | Roots',
  location: 'Location | Locations',
  locationId: 'Location id',
  // job || load
  job: 'Job | Jobs',
  jobDisplayName: 'Load No',
  jobStartedAtUtc: 'Start time',
  jobFinishedAtUtc: 'End time',
  // sensor || meaning || signal
  sensor: 'Sensor',
  signal: 'Signal | Signals',
  unit: 'Unit | Units',
  recipe: 'Recipe | Recipes',
  scadaType: 'Scada type',
  materialSystemList: 'Material Systems',
  measure: 'Measure | Measures',
  setpoint: 'Setpoint | Setpoints',
  reportId: 'Report No.',
  report: 'Report',
  reporter: 'Reporter',
  jobId: 'Job id',
  partId: 'Part id',
  part: 'Part',
  step: 'Step',
  recipeStep: 'Step',
  material: 'Material',
  drawingReference: 'Drawing reference',
  displayName: 'Name',
  preset: 'Preset',
  materialCalculationModel: 'Material calculation model',
  data: 'Data',
  chart: 'Chart | Charts',
  austenite: 'Austenite',
  gasComposition: 'Gas composition',
  generalInformation: 'General information',
  limitMinus: 'Limit -',
  limitPlus: 'Limit +',
  envelope: 'Envelope',
  email: 'E-Mail',
  sms: 'SMS',
  upload: 'Upload',
  orientation: 'Orientation',
  height: 'Height',
  width: 'Width',
  title: 'Title',
  send: 'Send',
  fullName: 'Full Name',
  production: 'Production',
  color: 'Color',
  dataSourceId: 'Data source',
  dataSourceReference: 'Data source reference',

  // TODO: migrate to "common"
  createdAt: 'Created at',
  createdBy: 'Created by',
  deletedAt: 'Deleted at',
  deletedBy: 'Deleted by',
  deleted: 'Deleted',
  lastModifiedAt: 'Modified on',
  lastModifiedBy: 'Modified by',
  revision: 'Revision',
  showDeleted: 'Show deleted',
  overwrite: 'Overwrite',
  requirement: 'Requirement',
  result: 'Result',

  schaefflerDiagram: 'Schäffler Diagramm',
  CCTDiagram: 'CCT diagram',
  temperingCurveDiagram: 'Tempering curve',
  jominyDiagram: 'Jominy curve',
  profileChart: 'Profile chart',
  processValuesChart: 'Process values chart',
  profileTable: 'Profile table',

  carbonPotential: 'Carbon potential',
  nitrogenPotential: 'Nitrogen potential',
  surfaceCarbon: 'Surface carbon',
  surfaceNitrogen: 'Surface nitrogen',
  surfaceCarbide: 'Surface Carbide',

  recipeStage: 'Recipe stage',
  automat: 'Automat | Automats',
  area: 'Area | Areas',
  component: 'Component | Components',
  equipment: 'Equipment | Equipments',
  equipmentGroup: 'Equipment group | Equipment groups',
  sparePart: 'Spare part | Spare parts',
  manufacturer: 'Manufacturer',
  partNumber: 'Part number',
  chamber: 'Chamber | Chambers',
  company: 'Company | Companies',
  heatTreatmentCapability: 'Heat treatment capability | Heat treatment capabilities',
  preference: 'Preference | Preferences',
  heatTreatmentProcess: 'Heat Treatment process | Heat treatment processes',

  processFlow: 'Processflow | Processflows',
  machine: 'Machine | Machines',
  zone: 'Zone | Zones',

  // Diffusion / simulation inputs — shared by the Diffusion Inputs panel
  // (form-pt9800-diffusion-inputs.vue) and the /simulator page. Wording mirrors the simulator.
  alloyFactor: 'Alloy factor C',
  carbonContent: 'Core carbon content',
  carbideLimit: 'Carbide limit',
  carbonMonoxide: 'Carbon monoxide CO',
  hydrogen: 'Hydrogen H₂',
  quenchingIntensity: 'Quenching intensity',
  representativeDiameter: 'Representative coupon diameter (DIN 17211)',
  requiredHardness: 'Effective case hardness',
  grainSize: 'ASTM grain size number',
  endTemperature: 'End temperature',
  carburizingDepth: 'Carburizing depth',
  nitridingDepth: 'Effective hardness depth (NHD)',
  referenceCarbon: 'Carbon at carb. depth',
  targetSurfaceCarbon: 'Target surface carbon',
};

// used in tables or other places where you need to filter by general term
export const generalTermFilter = {
  asset: 'Search asset',
};
